export const PLUGIN_POPUP_PENDING_KEY = 'darkfeld-plugin-auth-popup';
export const SYMBIOTE_POPUP_PENDING_KEY = 'darkfeld-symbiote-auth-popup';

export interface SymbioteTokenMessage {
  type: 'DARKFELD_SYMBIOTE_TOKEN';
  token: string;
  nonce: string;
}

/** Validate the token relay sent between the nested OAuth and TaleSpire popups. */
export function isSymbioteTokenMessage(
  origin: string,
  expectedOrigin: string,
  data: unknown,
  expectedNonce: string,
): data is SymbioteTokenMessage {
  if (origin !== expectedOrigin || !expectedNonce || !data || typeof data !== 'object') return false;
  const candidate = data as Partial<SymbioteTokenMessage>;
  return candidate.type === 'DARKFELD_SYMBIOTE_TOKEN'
    && candidate.nonce === expectedNonce
    && typeof candidate.token === 'string'
    && candidate.token.startsWith('eyJ');
}
